/**
 * Model for the CreateBarcodeLabel API — generates ZPL label data for wireless printing.
 * Used at MoC/AFT sites where printing goes directly from device to printer via ADMPrintApp.
 */

export interface CreateBarcodeLabelInput {
    containerId: string;
    warehouseId: string;
    associate: string;
    locale?: string;
}

export interface CreateBarcodeLabelOutput {
    label: string; // ZPL string (starts with ^XA, ends with ^XZ)
}

export const buildCreateBarcodeLabelInput = (
    containerId: string,
    warehouseId: string,
    associate: string,
    locale?: string
): CreateBarcodeLabelInput => {
    return {
        containerId,
        warehouseId,
        associate,
        locale
    };
};
